<div class="out-of-stock-container">
  <p>{{ 'NOT_IN_STOCK' | translate }}</p>
</div>
